import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtmlAndConvert',
  standalone: true
})
export class StripHtmlAndConvertPipe implements PipeTransform {

 transform(value: string, limit?: number): string {
  if (!value) return '';

  // Remove HTML tags using a regex
  const text = value.replace(/<[^>]*>/g, '');

  // If no limit is provided or limit is less or equal to 0, return full text
  if (!limit || limit <= 0) {
    return text;
  }

  // If text is shorter than limit, return as is
  if (text.length <= limit) {
    return text;
  }

  // Otherwise, truncate and add "..."
  return text.substring(0, limit) + '...';
  }


}
